const TOP_CATEGORIES = [
  {
    title: 'Air Conditioning',
    category: 'Air Conditioning',
  },
  {
    title: 'Florists',
    category: 'Florists',
  },
  {
    title: 'Reliable Removalists',
    category: 'Removalists',
  },
  {
    title: 'Affordable Self Storage',
    category: 'Self Storage',
  },
  {
    title: 'Cheap Batteries',
    category: 'Batteries',
  },
  {
    title: 'Kitchen Renovations & Designers',
    category: 'Kitchen Renovations & Designers',
  },
  {
    title: 'Expert Fencing Contractors',
    category: 'Fencing Contractors',
  },
  {
    title: 'Professional Funeral Director',
    category: 'Funeral Director',
  },
  {
    title: 'Landscape Supply Yards',
    category: 'Landscape Supplies',
  },
  {
    title: 'Real Estate Agencies',
    category: 'Real Estate Agencies',
  },
  {
    title: 'Sign Shops',
    category: 'Sign Shops',
  },
  {
    title: 'Solar Power Systems Suppliers',
    category: 'Solar Power Systems',
  },
  {
    title: 'Cheap Tyres',
    category: 'Tyres',
  },
  {
    title: 'Shed Builders',
    category: 'Sheds',
  },
  {
    title: 'Lawn Mowing Services',
    category: 'Lawn Mowing Services',
  },
  {
    title: 'Restaurants',
    category: 'Restaurants',
  },
];
const TOP_LOCATIONS = [
  {
    url_slug: 'gold-coast-qld',
    breadcrumb: 'Gold Coast',
  },
  {
    url_slug: 'sunshine-coast-qld',
    breadcrumb: 'Sunshine Coast',
  },
  {
    url_slug: 'darwin-nt',
    breadcrumb: 'Darwin',
  },
  {
    url_slug: 'cairns-qld',
    breadcrumb: 'Cairns',
  },
  {
    url_slug: 'newcastle-nsw',
    breadcrumb: 'Newcastle',
  },
  {
    url_slug: 'wollongong-nsw',
    breadcrumb: 'Wollongong',
  },
  {
    url_slug: 'central-coast-nsw',
    breadcrumb: 'Central Coast',
  },
  {
    url_slug: 'townsville-qld',
    breadcrumb: 'Townsville',
  },
  {
    url_slug: 'toowoomba-qld',
    breadcrumb: 'Toowoomba',
  },
  {
    url_slug: 'coffs-harbour-nsw',
    breadcrumb: 'Coffs Harbour',
  },
  {
    url_slug: 'port-macquarie-nsw',
    breadcrumb: 'Port Macquarie',
  },
  {
    url_slug: 'albury-nsw',
    breadcrumb: 'Albury',
  },
  {
    url_slug: 'bathurst-nsw',
    breadcrumb: 'Bathurst',
  },
  {
    url_slug: 'byron-bay-nsw',
    breadcrumb: 'Byron Bay',
  },
  {
    url_slug: 'rockhampton-qld',
    breadcrumb: 'Rockhampton',
  },
  {
    url_slug: 'mackay-qld',
    breadcrumb: 'Mackay',
  },
  {
    url_slug: 'alice-springs-nt',
    breadcrumb: 'Alice Springs',
  },
  {
    url_slug: 'taree-nsw',
    breadcrumb: 'Taree',
  },
];

export { TOP_LOCATIONS, TOP_CATEGORIES };
